<template>
  <div>
    <PageAllow controller="Purchases" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color py-4 mx-4">
        <!-- 发货单信息 -->
        <v-expansion-panels v-model="panelsDetail" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{ $t("DeliveryDetail.title") }}
                <v-chip
                  class="ms-4 mt-1"
                  small
                  label
                  :color="purchase.delivery_flg | deliverFlgsColor"
                  :text-color="purchase.delivery_flg | deliverFlgsTextColor"
                >
                  {{ purchase.delivery_flg | deliverFlgsText }}
                </v-chip>
                <v-chip
                  class="ms-4 mt-1"
                  small
                  label
                  :color="purchase.check_flg | checkFlgsColor"
                  :text-color="purchase.check_flg | checkFlgsTextColor"
                >
                  {{ purchase.check_flg | checkFlgsText }}
                </v-chip>
                <v-spacer />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    v-if="accountUser && accountUser.supplier.delivery_flg == 1"
                    small
                    dark
                    :color="purchase.logistics_json ? 'orange' : 'primary'"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="
                      editLogisticAlert = true;
                      currentItem = purchase;
                    "
                  >
                    <!-- <v-icon x-small class="pe-1">fa-sync-alt</v-icon> -->
                    {{ $t("Delivery.Fields.logistic") }}
                  </v-btn>
                  <v-btn
                    small
                    dark
                    color="print"
                    class="px-2 me-2 mb-1 elevation-1"
                    :href="'/#/print/delivery-print/' + this.$route.params.id"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-sync-alt</v-icon> -->
                    {{ $t("DeliveryDetail.Fields.print") }}
                  </v-btn>
                  <v-btn
                    v-if="accountUser && accountUser.supplier.cloud_print_flg"
                    small
                    dark
                    color="print"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="cloudPrint(this.$route.params.id)"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-sync-alt</v-icon> -->
                    {{ $t("Delivery.Fields.cloud_print") }}
                  </v-btn>

                  <v-btn
                    v-if="checkFlg"
                    small
                    dark
                    color="print"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="check()"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                    {{ $t("Delivery.Fields.check") }}
                  </v-btn>

                  <v-btn
                    v-if="deliveryFlg"
                    small
                    dark
                    color="print"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="delivery()"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                    {{ $t("Delivery.Fields.delivery") }}
                  </v-btn>
                </v-sheet>
              </v-card-title>
            </v-expansion-panel-header>
            <v-divider />

            <v-expansion-panel-content>
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.purchase_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ purchase.purchase_code }}
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ purchase.created | formatTime }}
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.hope_delivery_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ purchase.hope_delivery_date | formatDate }}
                    </span>
                  </v-card>
                </v-col>

                <v-col cols="12" md="8">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{
                        $t("DeliveryDetail.Fields.account_name", [
                          $consts.shopName(),
                        ])
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="purchase.stock_order != null">
                      {{
                        purchase.stock_order
                          ? purchase.stock_order.shop.shop_name
                          : ""
                      }}
                    </span>
                    <span v-if="purchase.stock_order == null">
                      {{ purchase.stock ? purchase.stock.name : "" }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 收货人 -->
                <v-col cols="12" md="4" v-if="settings && settings.show_purchase_address">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.consignee") }}{{ $t("Global.colon") }}
                    </span>
                    <!-- 普通采购单：取仓库负责人，若为空，则取仓库名称 -->
                    <span v-if="purchase.origin_flg == 101">
                     <span v-if="purchase.delivery_info">
                        {{ purchase.delivery_info.receiver_phone }}
                      </span>
                    </span>

                    <!-- 订单转采购：门店信息中的负责人名字 -->
                    <span v-else>
                      {{ purchase.delivery_info ? purchase.delivery_info.receiver_name : ""}}
                      <span v-if="purchase.delivery_info">
                        {{ purchase.delivery_info.receiver_phone }}
                      </span>
                    </span>
                  </v-card>
                </v-col>

                <!-- <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.tel_number")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="purchase.delivery_info">
                      {{
                        purchase.delivery_info.tel
                          ? purchase.delivery_info.tel
                          : purchase.delivery_info.receiver_phone
                      }}
                    </span>
                  </v-card>
                </v-col> -->
                <v-col cols="12" md="12" v-if="settings && settings.show_purchase_address">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.address") }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="purchase && purchase.delivery_info">
                      <AddressText
                        :masterItem="purchase.delivery_info"
                        :detailAddress="
                          purchase.delivery_info.address
                            ? purchase.delivery_info.address
                            : purchase.delivery_info.receiver_address
                            ? '' +
                              purchase.delivery_info.receiver_province +
                              ' ' +
                              purchase.delivery_info.receiver_city +
                              ' ' +
                              purchase.delivery_info.receiver_area +
                              ' ' +
                              purchase.delivery_info.receiver_address
                            : ''
                        "
                      />
                    </span>
                  </v-card>
                </v-col>
                <!-- 配送点名称 -->
                <v-col cols="12" md="4" v-if="settings && settings.delivery_point">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("DeliveryDetail.Fields.delivery_point")}}{{ $t("Global.colon") }}
                  </span>
                    <span v-if="purchase.delivery_point_province_id">
                   {{  $t("DeliveryDetail.Fields.delivery_point_name", [purchase.delivery_point_code, purchase.delivery_point_name]) }}
                  </span>
                  </v-card>
                </v-col>
                <!-- 配送点负责人 -->
                <v-col cols="12" md="4" v-if="settings && settings.delivery_point">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("DeliveryDetail.Fields.delivery_point_manager")}}{{ $t("Global.colon") }}
                  </span>
                    <span>
                    {{ purchase.delivery_point_manager }}
                  </span>
                  </v-card>
                </v-col>
                <!-- 配送点联系方式 -->
                <v-col cols="12" md="4" v-if="settings && settings.delivery_point">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("DeliveryDetail.Fields.delivery_point_tel") }}{{ $t("Global.colon") }}
                  </span>
                    <span>
                    {{ purchase.delivery_point_tel }}
                  </span>
                  </v-card>
                </v-col>
                <!-- 配送点地址 -->
                <v-col cols="12" md="12" v-if="settings && settings.delivery_point">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("DeliveryDetail.Fields.delivery_point_address") }}{{ $t("Global.colon") }}
                  </span>
                    <span>
                    {{ purchase.delivery_point_full_address }}
                  </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("DeliveryDetail.Fields.memo")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ purchase.memo }}
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panelsDetail.find((p) => p == 1)
                      ? null
                      : panelsDetail.push(1);
                  "
                >
                  {{ $t("DeliveryDetail.activities.title") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="activities_details"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        {{ item.created | formatTime }}
                      </template>
                      <!-- operater_name -->
                      <template v-slot:item.operater_name="{ item }">
                        <span
                          v-if="
                            item.operater && item.operater.type == 4
                              ? true
                              : false
                          "
                        >
                          {{
                            item.operater && item.operater.supplier
                              ? item.operater.supplier.supplier_name
                              : ""
                          }}
                        </span>
                        <span v-else>
                          {{ item.operater ? item.operater.name : "" }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <!-- 对账单明细 -->
      <div class="px-4 pb-4">
        <v-card class="px-4">
          <v-toolbar flat class="transparent-background-color">
            <v-card-title class="ms-n4 py-0">
              {{ $t("DeliveryDetail.detail") }}
              <v-spacer />
            </v-card-title>
          </v-toolbar>
          <v-divider />

          <v-data-table
            :headers="headers"
            :items="purchaseDetails"
            :search="search"
            multi-sort
            disable-pagination
            hide-default-footer
            class="pb-2"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n3">
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        purchase_details
                          ? [
                              purchase_details.length > 0 ? 1 : 0,
                              purchase_details.length,
                              purchase_details.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="search"
                        clearable
                        :label="$t('Search.filter')"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-toolbar>
            </template>

            <template v-slot:footer>
              <v-row>
                <v-spacer />
                <v-col cols="12" sm="6" md="3">
                  <v-list-item>
                    <v-list-item-content>
                      <span class="secondary--text font-weight-bold">
                        {{ $t("DeliveryDetail.sum") }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-content class="align-end text-end">
                      <span class="accent--text font-weight-bold">
                        {{ $t("Global.money")
                        }}{{ purchase.total | formatMoney }}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </template>

            <!-- <template v-slot:item.different="{ item }">
                {{ (item.quantity - item.examine_num) }}
              </template> -->
            <template v-slot:item.quantity="{ item }">
              {{ item.quantity | formatTwoDot }}
            </template>
            <template v-slot:item.confirm_num="{ item }">
              <span v-if="purchase.delivery_flg == 0">
                {{ 0 | formatTwoDot }}
              </span>
              <span v-else>
                 {{ item.confirm_num | formatTwoDot }}
              </span>
            </template>
            <template v-slot:item.delivery_num="{ item }">
              {{ item.delivery_num | formatTwoDot }}
            </template>
            <!-- 计数单位数量 -->
            <template v-slot:item.count_unit_num="{ item }">
              <span>
                {{ item.count_unit_num }} / {{ item.count_unit }}
              </span>
            </template>
            <!-- price  -->
            <template v-slot:item.price="{ item }">
              <span v-if="item.negotiate_price_flg == 1">
                {{ $t("DeliveryDetail.Fields.negotiatePrices") }}
              </span>
              <span v-else>
                {{ $t("Global.money")
                }}{{
                  $numberFormatter.moneyFormatWithDotNoMoreThan(item.price, 2)
                }}
              </span>
            </template>
            <template v-slot:item.delivery_price_total="{ item }">
              <span v-if="item.negotiate_price_flg == 1">
                {{ $t("DeliveryDetail.Fields.negotiatePrices") }}
              </span>
              <span v-else>
                {{ $t("Global.money") }}{{ item.total | formatMoneyFloor }}
              </span>
            </template>

            <template v-slot:item.production_date="{ item }">
              {{ item.production_date | formatDate }}
            </template>
            <template v-slot:item.expired_date="{ item }">
              {{ item.expired_date | formatDate }}
            </template>
            <!-- 质检报告 -->
            <template v-slot:item.qualify_report_img="{ item }">
              <v-btn
                color="orange"
                style="color: white"
                class="my-1"
                small
                v-if="(item && item.qualify_report_img_url && item.qualify_report_img_url.length > 0)"
                @click.stop="
                  currentItem = item;
                  qualifyReportDialog = true;
                "
              >
                {{ $t("DeliveryDetail.Fields.qualify_report") }}
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-sheet>
    <DialogImages
      v-model="qualifyReportDialog"
      :img_url="(currentItem && currentItem.qualify_report_img_url) ? currentItem.qualify_report_img_url : []"
    />
    <EditLogisticAlert
      v-model="editLogisticAlert"
      :purchases = currentItem
      @editLogistic="getDeliveryFromAPI()"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import AddressText from "@/components/plugins/AddressText";
import Delivery from "@/api/delivery";
import Delevery from "@/api/delivery";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import DialogImages from "./plugins/DialoImages";
import EditLogisticAlert from "./plugins/EditLogisticAlert";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    AddressText,
    DialogImages,
    EditLogisticAlert,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.delivery"),
        disabled: false,
        href: "/delivery",
      },
      {
        text: i18n.t("Nav.deliveryDetail"),
        disabled: false,
        href: "/delivery",
      },
      {
        text: i18n.t("DeliveryDetail.title"),
        disabled: true,
        href: "/delivery",
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("DeliveryDetail.Fields.category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("DeliveryDetail.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("Materials.Fields.supply_code"),
          align: "start",
          sortable: false,
          value: "supply_code",
        },
        {
          text: i18n.t("DeliveryDetail.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("DeliveryDetail.Fields.price"),
          align: "end",
          sortable: false,
          value: "price",
        },
        // 申请量
        {
          text: i18n.t("DeliveryDetail.Fields.delivery_volume"),
          align: "end",
          sortable: false,
          value: "quantity",
        },
        // 小计
        {
          text: i18n.t("DeliveryDetail.Fields.sum"),
          align: "end",
          sortable: false,
          value: "delivery_price_total",
        },
        // 发货量
        {
          text: i18n.t("DeliveryDetail.Fields.delivery_num"),
          align: "end",
          sortable: false,
          value: "delivery_num",
        },
        {
          text: i18n.t("DeliveryDetail.Fields.default_unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        // 计数单位数量 (启用计数单位且订单转采购时显示)
        ...(this.settings && this.settings.count_unit && this.purchase && this.purchase.order_code ? [{
          text: i18n.t("DeliveryDetail.Fields.count_unit_num"),
          align: "end",
          sortable: false,
          value: "count_unit_num",
        }] : []),
        // 收货量
        {
          text: i18n.t("DeliveryDetail.Fields.receiving_volume"),
          align: "end",
          sortable: false,
          value: "confirm_num",
        },
      ];
      if (this.settings && this.settings.product_date_setting == 1) {
        headers.push(
          {
            text: i18n.t("DeliveryDetail.Fields.production_date"),
            align: "start",
            sortable: false,
            value: "production_date",
          },
          {
            text: i18n.t("DeliveryDetail.Fields.expired_date"),
            align: "start",
            sortable: false,
            value: "expired_date",
          }
        );
      }
      headers.push(
        {
          text: i18n.t("DeliveryDetail.Fields.memo"),
          align: "start",
          sortable: false,
          value: "memo",
        }
      )
      if (this.settings && this.settings.qualify_report_enable == 1)
      {
        headers.push(
          {
            text: i18n.t("DeliveryDetail.Fields.qualify_report"),
            align: "center",
            sortable: false,
            class: "text-no-wrap",
            value: "qualify_report_img",
          })
      }
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("DeliveryDetail.activities.Fields.time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("DeliveryDetail.activities.Fields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("DeliveryDetail.activities.Fields.operater_name"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    purchaseDetails() {
      let item = [];
      if (this.purchase_details) {
        this.purchase_details.forEach((detail) => {
          if (detail.stock_in_details && detail.stock_in_details.length > 1) {
            detail.stock_in_details.forEach((stockDetail) => {
              stockDetail.delivery_num = stockDetail.order_num
              stockDetail.supply_code = detail.supply_code
              stockDetail.quantity = detail.quantity
              item.push(stockDetail)
            })
          }else {
            detail.confirm_num = detail.examine_num
            item.push(detail)
          }
        })
      }
      return item
    },

    ...mapState(["accountInfo", "settings", "accountUser"]),
  },
  data: () => ({
    panels: [0],
    panelsDetail: [0],
    // Detail: [0],
    tab: null,
    search: "",
    purchase: {},
    purchase_details: [],
    activities_details: [],
    deliveryFlg: null,
    checkFlg: null,
    currentItem: null,
    qualifyReportDialog: false,
    editLogisticAlert: false,
  }),

  mounted() {
    this.getDeliveryFromAPI();
  },

  methods: {
    getDeliveryFromAPI() {
      Delivery.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchase = response.data.purchase;
            this.purchase_details = response.data.purchase.purchase_details;
            this.activities_details = response.data.order_activities;
            this.deliveryFlg = response.data.purchase.actions.delivery;
            this.checkFlg = response.data.purchase.actions.check;
          }
        }.bind(this)
      );
    },
    delivery() {
      this.$router.replace("/delivery/edit/" + this.$route.params.id);
      // this.$store.dispatch("fullscreenLoading");
      // Delivery.delivery(this.$route.params.id).then(
      //   function (response) {
      //     if (response.data.status.isOK()) {
      //       this.getDeliveryFromAPI();
      //     }
      //     this.$store.dispatch("fullscreenLoadingStop");
      //   }.bind(this)
      // );
    },
    check() {
      Delivery.check(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getDeliveryFromAPI();
          }
        }.bind(this)
      );
    },
    cloudPrint(id) {
      //获取单据详情
      Delevery.print(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            let purchase = response.data.purchase;
            if (purchase.delivery_info)
              purchase.delivery_info = this.$printUtils.addCitiesName(purchase.delivery_info);
              purchase.purchase_details = purchase.purchase_details.map((detail) => {
                if (detail.negotiate_price_flg == 1) {
                  // 显示后议价
                  // 单价
                  detail.price = this.$t("DeliveryDetail.Fields.negotiatePrices");
                  // 采购金额
                  detail.delivery_price_total = this.$t("DeliveryDetail.Fields.negotiatePrices");
                }else {
                  detail.delivery_price_total = detail.total;
                }
                return detail;
              });
            CloudPrintTemplates.print({
              print_template_code: "supplierPurchase",
              object: purchase
            })
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>